const toKebabCase = (str: string): string => {
  if (typeof str !== "string" || !str) return "";
  return str.trim().replaceAll(" ", "-").toLowerCase();
};

const getTrackName = (el: HTMLElement): string => {
  const tagName = el.tagName.toLowerCase();
  const identifier = el.getAttribute("aria-label")
    || el.getAttribute("title")
    || el.getAttribute("placeholder")
    || el.textContent?.trim()
    || "click";
  return `${tagName}-${identifier}`;
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("track", {
    async mounted(el: HTMLElement, binding) {
      const trackingValue = binding.value || binding.arg || await getTrackName(el);
      el.setAttribute("data-track", toKebabCase(trackingValue));
    },
  });
});
